// All spots
export const GET_ALL_SPOT = 'GET_ALL_SPOT'
export const GET_ALL_SPOT_SUCCESS = 'GET_ALL_SPOT_SUCCESS'
export const GET_ALL_SPOT_ERROR = 'GET_ALL_SPOT_ERROR'
export const GET_ALL_SPOT_END = 'GET_ALL_SPOT_END'

// City spots
export const GET_CITY_SPOT = 'GET_CITY_SPOT'
export const GET_CITY_SPOT_SUCCESS = 'GETCITY_SPOT_SUCCESS'
export const GET_CITY_SPOT_ERROR = 'GET_CITY_SPOT_ERROR'
export const GET_CITY_SPOT_END = 'GET_CITY_SPOT_END'
